import Navigation from '../components/Navigation';
import About from '../components/About';
import Features from '../components/Features';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';

function App() {
  return (
    <div>
      <Navigation></Navigation>
      <About></About>
      <Features></Features>
      <Pricing></Pricing>
      <Footer></Footer>
    </div>
  );
}

export default App;
